import { gql } from "@apollo/client";

export const UpdateFeatures = gql`
mutation UpdateFeatures($idStore: ID!, $content: [contentFeatures]!) {
  updateFeatures(idStore: $idStore, content: $content) {
    status
  }
}
`;